<ngx-smart-modal
    #indexAdapterKit
    class="iak-modal"
    [identifier]="modalType"
    [title]="title"
    closable="false"
    dismissible="false"
    escapable="false"
    [closeButtonText]="closeButtonText"
    [confirmButtonText]="confirmButtonText"
    [disableConfirmButton]="!content">

    <small class="iak-helptext">Please enter a new custom index adapter kit or reload the template to edit it.</small>

    <div class="iak-body d-flex">
        <!-- Left column: controls -->
        <div class="iak-sidebar">
            <div class="template-chooser-label">
                <small>Template Type</small>
                <lib-popover
                    popoverType="info"
                    popoverTriggerEvents="mouseenter:mouseleave"
                    popoverSize="small"
                    popoverPlacement="right">
                    <span>Pre-defined templates for different types of Index Adapter Kits.</span>
                </lib-popover>
            </div>
            <lib-select #templateSelect
                placeholder="Select"
                (change)="onTemplateSelection($event)">
                <lib-option *ngFor="let template of templateOptions"
                    [label]="template.name"
                    [value]="template.content">
                </lib-option>
            </lib-select>

            <div class="format-section">
                <small>Format</small>
                <lib-radio-checkbox
                    type="radio"
                    name="format"
                    value="Yaml"
                    [checked]="definitionFormat === 'Yaml'"
                    (change)="onFormatChange('Yaml')">
                    YAML
                </lib-radio-checkbox>
                <lib-radio-checkbox
                    type="radio"
                    name="format"
                    value="Tsv"
                    [checked]="definitionFormat === 'Tsv'"
                    (change)="onFormatChange('Tsv')">
                    TSV
                </lib-radio-checkbox>
            </div>

            <button lib-btn
                secondary
                small
                type="button"
                class="iak-sidebar-btn"
                (click)="onDownloadTemplate($event)">
                Download Template
            </button>
            <button lib-btn
                secondary
                small
                type="button"
                class="iak-sidebar-btn"
                (click)="onReloadTemplate($event)">
                Reload Template
            </button>
            <button lib-btn
                secondary
                small
                type="button"
                class="iak-sidebar-btn"
                (click)="fileInput.click()">
                Import File
            </button>
            <input #fileInput
                hidden
                type="file"
                accept=".yaml,.yml,.tsv"
                (click)="fileInput.value = null"
                (change)="onImportIakDefinitionFile($event)" />
        </div>

        <!-- Right column: editor -->
        <div class="ace-editor-container">
            <!-- Ace Editor -->
            <ace [config]="config"
                [(value)]="content">
            </ace>
        </div>
    </div>

    <!-- Skip Index Diversity Validation Checkbox  -->
    <lib-radio-checkbox type="checkbox"
        [checked]="isSkipIndexDiversityValidation"
        (change)="toggleSkipIndexDiversityValidation($event)">
        Override Index Diversity Check
    </lib-radio-checkbox>
    <!-- Error message Banner -->
    <div #scrollbarContainer
        class="error-message"
        [hidden]="!errorMessage">
        <span>{{ errorMessage }}</span>
    </div>
</ngx-smart-modal>
